const phases = { close_check: 0, collect: 1, statistic: 2 }

// Keep ordinary chat in arrival order; order period cards independently of WS timing.
export function orderPeriodMessages(messages) {
  const result = []
  const groups = new Map()
  const seen = new Map()
  for (const message of messages) {
    const data = message.data || {}
    const period = data.game_no || data.game?.game_no
    if (!(message.type in phases) || !period) {
      result.push(message)
      continue
    }
    // This list belongs to one game room; close_check has no game_id in its payload.
    const group = String(period)
    const page = message.type === 'statistic' ? Number(data.page?.index || 1) : 0
    const key = `${group}:${message.type}:${page}`
    if (seen.has(key)) {
      const index = seen.get(key)
      result[index] = { ...message, id: result[index].id }
      continue
    }
    const index = result.length
    seen.set(key, index)
    if (!groups.has(group)) groups.set(group, [])
    groups.get(group).push(index)
    result.push(message)
  }
  for (const indexes of groups.values()) {
    const cards = indexes.map((index) => result[index]).sort((a, b) =>
      phases[a.type] - phases[b.type]
      || Number(a.data?.page?.index || 1) - Number(b.data?.page?.index || 1))
    indexes.forEach((index, offset) => { result[index] = cards[offset] })
  }
  return result
}
